import { z } from 'zod'

export const schema = z.object({
  value_date: z.iso.date(),
  chosen_jobs: z.array(z.string()).min(1).default([]),
  force_historical: z.boolean().default(false),
  only_tickers: z.array(z.string()).default([]),
  skip_closed_european: z.boolean().default(false),
  ticker_cooldown_minutes: z.number().int().nonnegative().optional(),
  job_cooldown_minutes: z.number().int().nonnegative().optional(),
})

export type SchemaType = z.infer<typeof schema>
